export const NUMBER_CLEAR_REGEX = /[^\d,.:]/gi;
export const INTEGER_TEST = /^[1-9][0-9]*$/;
export const DECIMAL_TEST = /^(0|[1-9][0-9]*)?(\.[0-9]*)?$/;
export const MONEY_TEST = /^(0|[1-9][0-9]*)?(\.[0-9]{0,2})?$/;
export const TIME_TEST = /^\d{1,2}(:\d{1,2})?$/;
